import dayjs from "dayjs";
import { ChannelEnum, TypeEnum } from "../constants/enums";
import { getChannelCost } from "../constants/cost";
import { CampaignDetails } from "../models/campaign";
import { CampaignFormValues } from "../models/formValues";
import { removeLink, removeWhatsappAdditionalMessage, whatsappTextToHtml } from "./convert";

export const ALL_BRAND = "All Brands";

const nn = <T,>(v: T | null | undefined): T | undefined => v ?? undefined;

export const mapCampaignToFormValues = (
  data: CampaignDetails,
): Partial<CampaignFormValues> => {
  const segments = data.Segments?.map((s) => s.SegmentId) ?? [];
  const postalCodes =
    data.PostalDistricts?.map((p) => String(p.DistrictId)) ?? [];

  const firstMessage = data.Messages?.[0];
  const message = firstMessage?.Content || "";

  let cleaned = removeLink(message);
  cleaned = removeWhatsappAdditionalMessage(cleaned);
  const formattedMessage =
    data.Channel === ChannelEnum.WhatsAppStandard ||
    data.Channel === ChannelEnum.WhatsAppPremium
      ? whatsappTextToHtml(cleaned)
      : cleaned;
  return {
    Name: data.Name ?? "",
    Type: nn(data.Type),
    Status: nn(data.Status),
    Link: firstMessage?.Link,
    Period: nn(data.RFMPeriod),
    Segments: segments,
    Profile: nn(data.RFMProfile),
    ageRange:
      data.FromAge != null || data.ToAge != null
        ? { from: Number(data.FromAge), to: Number(data.ToAge) }
        : undefined,
    PostalCode: postalCodes,
    CampaignDate: data.CampaignStart ? dayjs(data.CampaignStart) : undefined,
    Budget: nn(data.Budget),
    Message: nn(formattedMessage),
    Voucher: nn(data.VoucherId),
    Image: nn(data.ImageUrl),
    CostPerMember: getChannelCost(data?.Channel ?? null),
    PurchaseBrand:
      data?.PurchaseBrandList && data.PurchaseBrandList.length > 0
        ? data.PurchaseBrandList
        : [ALL_BRAND],
    ScheduleType:
      data?.ScheduleType === TypeEnum.Recurring_Monthly ||
      data?.ScheduleType === TypeEnum.Recurring_Weekly
        ? TypeEnum.Recurring_Weekly
        : TypeEnum.Onetime,
    Mode: data?.Mode,
    TemplateType: data.TemplateType ?? undefined,
    InactiveDays: data.InactiveDays ?? undefined,
    ScheduleEndType: data.ScheduleEndType ?? undefined,
    Frequency:
      data.ScheduleType && data.ScheduleType !== TypeEnum.Onetime
        ? data.ScheduleType
        : undefined,
    RepeatMonth: data.RepeatMonth ?? undefined,
    MaxOccurrences: data.MaxOccurrences ?? undefined,

    RepeatDays: data.RepeatDaysList ?? undefined,
    EndDate: data.EndDate ? dayjs(data.EndDate) : undefined,
    Retargeting: data.Retargeting != null ? data.Retargeting : false,
    ExtensionDays: data.ExtensionDays ?? undefined,
    CustomCopyText: data.Messages?.[0]?.CustomCopyText ?? undefined,
    CustomUrl: data.Messages?.[0]?.CustomUrl ?? undefined,
    MessageSubject: firstMessage?.MessageSubject ?? undefined,
    MessagePreheader: firstMessage?.MessagePreheader ?? undefined,
    IncompleteProfileFields: data.IncompleteProfileFields ?? undefined,
  };
};
